import { AuthModalComponent } from '@app/core/user/containers/auth-modal/auth-modal.component';
import { Injectable } from '@angular/core';
import { CanDeactivate, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { Store } from '@ngrx/store';
import { MatDialog } from '@angular/material/dialog';
import { PlatformService } from '@app/shared/services/platform/platform.service';
import { CatalogMatcher } from '@app/+catalog/catalog-page-routing.module';
import { landingPageUrlMatcher } from '@app/landings/landing-routes';
import { SessionCookieService } from '@app/core/cookies';
import { LogoutSuccess } from '@app/core/user/store/actions';
import { ResetCounters } from '@app/core/header/store';

@Injectable()
export class IsLoggedGuard implements CanActivate, CanDeactivate<boolean> {
  constructor(
    public dialog: MatDialog,
    private store: Store<any>,
    private platform: PlatformService,
    private sessionService: SessionCookieService
  ) {}

  openDialog() {
    const config: any = {
      disableClose: false,
      maxWidth: 1280,
      data: {
        type: 'login',
        forced: true
      }
    };

    this.dialog.open(AuthModalComponent, config);
  }

  isLoggedIn(): boolean {
    const isAuthenticated = this.sessionService.hasSession() && this.sessionService.hasUserId();

    if (!this.platform.isBrowser) {
      return true;
    }
    if (!isAuthenticated) {
      // Case when authenticated in store but cookie not present
      this.store.dispatch(new LogoutSuccess());
      this.openDialog();
    }
    return isAuthenticated;
  }

  canActivate(): boolean {
    return this.isLoggedIn();
  }

  canDeactivate(
    _component: boolean,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean {
    if (this.isProductUrl(nextState.url) && !this.isLandingPage(nextState.url)) {
      return this.isLoggedIn();
    }
    return true;
  }

  isProductUrl(url: string): boolean {
    return /.*\/.*\/.*\/.*-([0-9]+)\.shtml$/.test(url);
  }

  isCatalogUrl(url: string): boolean {
    return CatalogMatcher(this.urlStringToUrlSegment(url)) !== null;
  }

  isLandingPage(url: string): boolean {
    return landingPageUrlMatcher(this.urlStringToUrlSegment(url)) !== null;
  }

  urlStringToUrlSegment(url: string): UrlSegment[] {
    return url
      .replace(/^\/|\/$/g, '')
      .split('/')
      .map(e => new UrlSegment(e, {}));
  }
}
